module.exports = __webpack_public_path__ + "img/pic-3-1.baaa763f.png";